var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "job-preview-content-data-outline-sp",
    {
      staticClass: "plr20 mt15 -company",
      attrs: { "update-date": _vm.environment.updateDate },
    },
    [
      _c(
        "div",
        { staticClass: "data-area pt20" },
        [
          _c("job-preview-content-pie-data-sp", {
            staticClass: "mb15",
            attrs: {
              title: "女性社員の割合",
              value: _vm.environment.womanRate,
            },
          }),
          _vm._v(" "),
          _c("job-preview-content-pie-data-sp", {
            staticClass: "pacentage-manage mb15",
            attrs: {
              title: "女性役員・管理職の割合",
              value: _vm.environment.officerRate,
            },
          }),
          _vm._v(" "),
          _c("job-preview-content-bar-data-sp", {
            staticClass: "mb15",
            attrs: {
              title: "残業時間（平均）",
              value: _vm.environment.overtime,
              "average-value": _vm.average.environment.overtime,
              unit: "時間",
            },
          }),
          _vm._v(" "),
          _c("job-preview-content-bar-data-sp", {
            staticClass: "mb15",
            attrs: {
              title: "有給取得率",
              value: _vm.environment.ptoRate,
              "average-value": _vm.average.environment.pto,
              unit: "%",
            },
          }),
          _vm._v(" "),
          _c("job-preview-content-bar-data-sp", {
            staticClass: "mb15",
            attrs: {
              title: "育休取得率",
              value: _vm.environment.maternityRate,
              "average-value": _vm.average.environment.maternity,
              unit: "%",
            },
          }),
          _vm._v(" "),
          _c("job-preview-content-bar-data-sp", {
            staticClass: "average-lengthofservice mb15",
            attrs: {
              title: "女性社員の平均勤続年数",
              value: _vm.environment.lengthService,
              "average-value": _vm.average.environment.lengthService,
              unit: "年",
            },
          }),
          _vm._v(" "),
          _vm.certificateCount
            ? _c(
                "section",
                { staticClass: "data certificate mb20" },
                [
                  _c("p", { staticClass: "hd-type-04 mr5" }, [
                    _c("span", [_vm._v("国認定")]),
                  ]),
                  _vm._v(" "),
                  _c("job-preview-content-data-tooltip-sp"),
                  _vm._v(" "),
                  _c("ul", { staticClass: "mt20" }, [
                    _c("li", { class: _vm.environment.isKurumin ? "on" : "" }, [
                      _vm._v("\n          くるみん\n        "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "li",
                      { class: _vm.environment.isPlatinumKurumin ? "on" : "" },
                      [_vm._v("\n          プラチナくるみん\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { class: _vm.environment.isNadeshiko ? "on" : "" },
                      [_vm._v("\n          なでしこ銘柄\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { class: _vm.environment.isEruboshi ? "on" : "" },
                      [_vm._v("\n          えるぼし\n        ")]
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.environment.womanAction
            ? _c("section", { staticClass: "data other mb10" }, [
                _c("p", { staticClass: "hd-type-04 mr5" }, [
                  _c("span", [_vm._v("その他の取り組み")]),
                ]),
                _vm._v(" "),
                _c("p", {
                  staticClass: "mt20 pega-pre-wrap",
                  domProps: {
                    textContent: _vm._s(_vm.environment.womanAction),
                  },
                }),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }